module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.3.6 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/cell.html"
    }
  }, [_vm._v("Cell")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持多个箭头样式变量")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加 slot:title")]), _vm._v(" "), _c('li', [_vm._v("[feature] 添加 prop:readonly")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复 scroller 支持数字类型引入的 bug #1406")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/inline-calendar.html"
    }
  }, [_vm._v("InlineCalendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] render-function 参数 day => date（在 3.0 版本前不会影响目前使用）#1361")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup-radio.html"
    }
  }, [_vm._v("PopupRadio")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加 prop:readonly")]), _vm._v(" "), _c('li', [_vm._v("[feature] 添加 slot:icon")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/search.html"
    }
  }, [_vm._v("Search")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 添加方法 setBlur")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/spinner.html"
    }
  }, [_vm._v("Spinner")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 prop:size #1447")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/string.html"
    }
  }, [_vm._v("String")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 可以直接引用 trim 代替原来的 stringTrim")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-43a94197", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-43a94197"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.3.6-234.vue
// module id = 2193
// module chunks = 300